import {
    DialogContentText,
    useTheme
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, CancelButton } from '../common/ActionButtons';
import {
    StyledDialog,
    StyledDialogActions,
    StyledDialogContent,
    StyledDialogTitle
} from '../data-sources/CreateDataSourceDialog.styled';

interface ConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
                                                                   open,
                                                                   onClose,
                                                                   onConfirm,
                                                                   title,
                                                                   message,
                                                                   confirmButtonText,
                                                                   cancelButtonText
                                                               }) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <StyledDialogTitle>{title}</StyledDialogTitle>
            <StyledDialogContent>
                <DialogContentText id="confirmation-dialog-description" sx={{fontFamily: 'Manrope, sans-serif'}}>
                    {message}
                </DialogContentText>
            </StyledDialogContent>
            <StyledDialogActions>
                <CancelButton onClick={onClose}>
                    {cancelButtonText || t('confirmationDialog.cancel')}
                </CancelButton>
                <ActionButton
                    onClick={onConfirm}
                    style={{
                        backgroundColor: theme.palette.error.main,
                        color: 'white'
                    }}
                >
                    {confirmButtonText || t('confirmationDialog.confirm')}
                </ActionButton>
            </StyledDialogActions>
        </StyledDialog>
    );
};

export default ConfirmationDialog;
